import { createSelector } from 'reselect';
const selectScribe = (state) => state.scribe;
export const selectIsScribing = createSelector([selectScribe], (scribe) => scribe.scribing);
export const selectSpeakerListened = createSelector([selectScribe], (scribe) => scribe.speakerListened);
